import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Tag } from '../../types/tag';

interface AddModalProps {
    tag: Tag;
    isOpen: boolean;
    toggle: () => void;
}

const TagModal = ({ tag, isOpen, toggle }: AddModalProps) => {
    const [selectedTab, setSelectedTab] = useState<'admanager' | 'tagmanager' | 'html'>('html');
    const [includePrebid, setIncludePrebid] = useState<boolean>(true);

    const handleCopy = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success('Código copiado!');
    };

    const toggleAddModal = () => {
        toggle();
    };

    const headScriptWithPrebid = `<link rel="preconnect" href="https://tag.adpulse.com.br"/>
<link rel="preconnect" href="https://securepubads.g.doubleclick.net"/>
<script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" async></script>
<script>(function(d){var p=d.createElement('script');p.async=true;p.src='https://tag.adpulse.com.br/prebid.js';var o=d.createElement('script');o.async=true;o.src='https://tag.adpulse.com.br/adp-${tag.id}.js';var s=d.getElementsByTagName('script')[0];s.parentNode.insertBefore(o,s);s.parentNode.insertBefore(p,s);})(document);</script>`;

  const headScriptWithoutPrebid = `<link rel="preconnect" href="https://tag.adpulse.com.br"/>
<link rel="preconnect" href="https://securepubads.g.doubleclick.net"/>
<script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" async></script>
<script>(function(d){var o=d.createElement('script');o.async=true;o.src='https://tag.adpulse.com.br/adp-${tag.id}.js';var s=d.getElementsByTagName('script')[0];s.parentNode.insertBefore(o,s);})(document);</script>`;

    const adUnitScript = `<div data-adp-adunit="/63510415/general_test"
     data-adp-refresh="30"
     data-adp-sizes="336x280,300x250"
></div>
<script>
(window.adptag = window.adptag || {cmd: []}).cmd.push({});
</script>`;

    const headerScript = `<script src="https://tag.adpulse.com.br/adp-${tag.id}.js" async></script>`;
    const adManagerAutoScript = headerScript;
    const tagManagerScript = headerScript;
    const adManagerScript = `${headerScript}
<div data-adp-adunit="%%ADUNIT%%"
     data-adp-sizes="%%WIDTH%%x%%HEIGHT%%"
     data-adp-targeting='%%PATTERN:TARGETINGMAP%%'
     data-adp-macros='{
        "site": "%%SITE%%",
        "url": "%%PATTERN:url%%",
        "click": "%%CLICK_URL_UNESC%%",
        "view": "%%VIEW_URL_UNESC%%"
     }'
></div>
<script>
(window.adptag = window.adptag || {cmd: []}).cmd.push({});
</script>`;

    return (
        <div className={`modal ${isOpen ? 'show d-block' : ''}`} id="showModal" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header bg-light p-3">
                        <h5 className="modal-title">Implementação da TAG</h5>
                        <button type="button" className="btn-close" onClick={toggleAddModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                <div style={{ marginBottom: 16 }}>
                    <p style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>
                        As TAGs do AdPulse são compatíveis com implementação via <strong>Ad Servers</strong> (Google Ad Manager, Amazon Publisher Services, etc.), 
                        <strong> Google Tag Manager</strong> e <strong>HTML</strong> (recomendado). 
                        Escolha a opção que melhor se adequa ao seu ambiente de desenvolvimento.
                    </p>
                </div>

                <div style={{ display: 'flex', gap: 8, marginBottom: 20, borderBottom: '1px solid #eee' }}>
                    <button
                        type="button"
                        className={`btn btn-link${selectedTab === 'html' ? ' active text-primary' : ' text-muted'}`}
                        onClick={() => setSelectedTab('html')}
                        style={{ textDecoration: 'none', fontWeight: selectedTab === 'html' ? 'bold' : 'normal' }}
                    >
                        HTML (Recomendado)
                    </button>
                    <button
                        type="button"
                        className={`btn btn-link${selectedTab === 'admanager' ? ' active text-primary' : ' text-muted'}`}
                        onClick={() => setSelectedTab('admanager')}
                        style={{ textDecoration: 'none', fontWeight: selectedTab === 'admanager' ? 'bold' : 'normal' }}
                    >
                        Google Ad Manager
                    </button>
                    <button
                        type="button"
                        className={`btn btn-link${selectedTab === 'tagmanager' ? ' active text-primary' : ' text-muted'}`}
                        onClick={() => setSelectedTab('tagmanager')}
                        style={{ textDecoration: 'none', fontWeight: selectedTab === 'tagmanager' ? 'bold' : 'normal' }}
                    >
                        Google Tag Manager
                    </button>
                </div>

                {selectedTab === 'html' && (
                    <div>
                        <h6 style={{ color: '#333', marginBottom: 16 }}>Implementação HTML</h6>
                        
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <input
                                    type="checkbox"
                                    id="includePrebid"
                                    checked={includePrebid}
                                    onChange={(e) => setIncludePrebid(e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label htmlFor="includePrebid" style={{ fontSize: 14, cursor: 'pointer', margin: 0 }}>
                                    Incluir Prebid.js (Header Bidding)
                                </label>
                            </div>
                        </div>
                        
                        <div style={{ marginBottom: 24 }}>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                1. Adicione a TAG abaixo dentro da seção <code>&lt;head&gt;</code> do seu site:
                            </p>
                            <div style={{ position: 'relative' }}>
                                <pre style={{ 
                                    background: '#f8f9fa', 
                                    padding: 12, 
                                    borderRadius: 6, 
                                    fontSize: 13,
                                    border: '1px solid #e9ecef',
                                    overflow: 'auto'
                                }}>
                                    {includePrebid ? headScriptWithPrebid : headScriptWithoutPrebid}
                                </pre>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleCopy(includePrebid ? headScriptWithPrebid : headScriptWithoutPrebid)}
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>

                        <div>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                2. Adicione a TAG abaixo nos blocos de anúncio da página:
                            </p>
                            <div style={{ position: 'relative' }}>
                                <pre style={{ 
                                    background: '#f8f9fa', 
                                    padding: 12, 
                                    borderRadius: 6, 
                                    fontSize: 13,
                                    border: '1px solid #e9ecef',
                                    overflow: 'auto'
                                }}>
                                    {adUnitScript}
                                </pre>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleCopy(adUnitScript)}
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {selectedTab === 'admanager' && (
                    <div>
                        <h6 style={{ color: '#333', marginBottom: 16 }}>Ad Servers</h6>
                        <p style={{ fontSize: 14, marginBottom: 16 }}>
                            Compatível com Google Ad Manager, Amazon Publisher Services e outros ad servers. 
                            Configure um item de linha como <strong>sponsorship</strong> com meta de entrega definida.
                        </p>
                        
                        <div style={{ marginBottom: 24 }}>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                Para formatos automáticos (script 1x1 com safe frame desativado):
                            </p>
                            <div style={{ position: 'relative' }}>
                                <pre style={{ 
                                    background: '#f8f9fa', 
                                    padding: 12, 
                                    borderRadius: 6, 
                                    fontSize: 13,
                                    border: '1px solid #e9ecef',
                                    overflow: 'auto'
                                }}>
                                    {adManagerAutoScript}
                                </pre>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleCopy(adManagerAutoScript)}
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>

                        <div>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                Para blocos de anúncio com tamanhos específicos (não recomendado):
                            </p>
                            <div style={{ position: 'relative' }}>
                                <pre style={{ 
                                    background: '#f8f9fa', 
                                    padding: 12, 
                                    borderRadius: 6, 
                                    fontSize: 13,
                                    border: '1px solid #e9ecef',
                                    overflow: 'auto'
                                }}>
                                    {adManagerScript}
                                </pre>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleCopy(adManagerScript)}
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {selectedTab === 'tagmanager' && (
                    <div>
                        <h6 style={{ color: '#333', marginBottom: 16 }}>Google Tag Manager</h6>
                        
                        <div style={{ marginBottom: 24 }}>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                1. Crie uma nova tag do tipo "HTML Personalizado" e adicione o código:
                            </p>
                            <div style={{ position: 'relative' }}>
                                <pre style={{ 
                                    background: '#f8f9fa', 
                                    padding: 12, 
                                    borderRadius: 6, 
                                    fontSize: 13,
                                    border: '1px solid #e9ecef',
                                    overflow: 'auto'
                                }}>
                                    {tagManagerScript}
                                </pre>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleCopy(tagManagerScript)}
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>

                        <div>
                            <p style={{ fontSize: 14, marginBottom: 8 }}>
                                2. Configure o acionador para disparar em todas as páginas do site.
                            </p>
                        </div>
                    </div>
                )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TagModal;